// @ts-check
import * as sentry from "./sentry"
import configClient from "../../api/hooks/config-client"
import { services as localeServices, homeProductTeaser as localeHomeProductTeaser } from "./config.de"

export const title = "Renz Shop"

let _apiBaseURL = typeof window !== "undefined" && window.localStorage?.getItem("apiBase")
const domain = "shop.renzgroup.de"
export const baseDomain = typeof window !== "undefined" ? document?.location?.hostname : domain
export const baseURL = "https://" + baseDomain
export const apiBaseURL = _apiBaseURL || configClient.apiClientBaseURL
export const email = "info@renz24.de"
export const OfferAssistantFTPAssetsUrl = "https://images.shop.renzgroup.de/original/offer/"

export const sentryDSN = "https://5063f9b5564d0fdece4e47a8e2e63672@sentry.basehosts.de/3"

export const sentryTracingOrigins = [
    "localhost",
    "renzshop.testversion.online",
    "dev.renzshop.testversion.online",
    "shop.renzgroup.de",
    /^\//,
    /renzshop/,
]
export const sentryEnvironment: string = "early"
export const release = configClient.release
console.log("Release: ", release)
export const websiteName = "Renz Shop"
export const companyName = "Erwin Renz Metallwarenfabrik GmbH & Co KG"
export const socialMedia = {
    instagram: "https://www.instagram.com/renz_dach/?hl=de",
    facebook: "https://www.facebook.com/RENZGroup/?locale=de_DE",
    xing: "https://www.xing.com/pages/erwinrenzmetallwarenfabrikgmbh-cokg",
    linkedIn: "https://www.linkedin.com/company/erwin-renz-metallwarenfabrik-gmbh-co-kg/?originalSubdomain=de",
}

// need to execute early for fetch wrapping
 sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment, release)

export const services = localeServices
export const homeProductTeaser = localeHomeProductTeaser

export const colorCodes: RALColor[] = configClient.colorCodes
export const colorGroup1: RALColor[] = configClient.colorGroup1

export const optionsConf = {
    rsa2: {
        title: "Sprech-/Klingelserie RSA2-kompakt",
        image: "/media/econfig/option-klingelserie.jpg",
        includedIn: [
            { line_code: 11, intercom_bell_code: 2 },
            { line_code: 11, intercom_bell_code: 3 },
            { line_code: 11, intercom_bell_code: 4 },
        ],
        icon: "/media/econfig/option-klingelserie-icon.png",
        text: `Platzsparendes Klingelsystem mit Antivandalismus-Ausstattung. 
			        Licht- bzw. Klingelknopf aus Edelstahl V4A mit rotem bzw. weißem LED-Leuchtring.
					Namensschild aus Edelstahl V4A, optional mit Gravur lieferbar..
					Namensschildwechsel von vorn mittels Spezialwerkzeug.
					Passende Namensschilder für den Briefeinwurf lieferbar.`,
    },
    "rsa2#second_name_tag": {
        title: "Zusätzliches Namensschild (RSA2)",
        image: "/media/econfig/option-namensschild.jpg",
        icon: "/media/econfig/option-namensschild-icon.png",
        text: `Planen Sie gleich zwei Namensschilder ein.
				    So kann im zweiten Schild „Werbung, nein danke!“ stehen, damit die Anlage später nicht mit unschönen Aufklebern übersät wird.
					Alternativ ist auch die Aufschrift „Werbung, ja bitte!“ lieferbar.`,
    },
    "-rsa2#second_name_tag": {
        title: "Zusätzliches Namensschild",
        image: "/media/econfig/option-namensschild.jpg",
        icon: "/media/econfig/option-namensschild-icon.png",
        text: `Planen Sie gleich zwei Namensschilder ein.
				    So kann im zweiten Schild „Werbung, nein danke!“ stehen, damit die Anlage später nicht mit unschönen Aufklebern übersät wird.
					Alternativ ist auch die Aufschrift „Werbung, ja bitte!“ lieferbar.`,
    },
    "rsa2#engraving": {
        title: "RSA2 mit Gravur",
        image: "/media/econfig/option-gravur.jpg",
        icon: "/media/econfig/option-gravur.svg",
        text: `TODO`,
    },
    rsk: {
        title: "Renz-System-Klappe RSK",
        image: "/media/econfig/option-klappensystem.jpg",
        icon: "/media/econfig/option-klappensystem-icon.png",
        includedIn: [{ line_code: 11 }],
        text: `Dämpfer für sanftes, kaum hörbares Schließen.
				    Eingebaute Feder, welche die Einwurfklappe dicht geschlossen hält, verhindert lästiges Klappern bei Wind (keine Treppenhausgeräusche).
					Integriertes Regenableitsystem für stets trockene Post.
					Bei Edelstahl-Modellen serienmäßig, bei pulverbeschichteten Modellen gegen Mehrpreis.`,
    },
    rs50: {
        title: "Schrägeinwurf RS50",
        image: "/media/econfig/option-schraegeinwurf.jpg",
        icon: "/media/econfig/option-schraegeinwurf-icon.png",
        text: `Mit dem RS50-Schrägeinwurf passt selbst die dicke Samstagszeitung in den Briefkasten.
					Zudem sorgen ein Gleitblech und zwei solide, gezackte Entnahmesicherungen für Schutz vor fremden Zugriffen.
				    Bei allen 145 mm tiefen Kästen kann der RS50-Schrägeinwurf gegen Mehrpreis geliefert werden.`,
    },
}

export const pricingRules: {
    from: number
    discount: number
}[] = configClient.pricingRules

export const menu1MegaMenuIdx = [0]
export const hideMegaMenuIdx = [0]

export const deployTarget = "de"

// convert ral array to map
export const ralMap: { [key: string]: RALColor } = {}
for (const ral of colorCodes) {
    ralMap[ral.RAL] = ral
}
